import styled from 'styled-components';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 540px 1fr;
	width: 100%;
	height: 100%;
	padding-left: 40px;
	transition: opacity 0.3s ease;

	&.container-enter {
		opacity: 0;
	}

	&.container-enter-active,
	&.container-enter-done,
	&.container-exit {
		opacity: 1;
	}

	&.container-exit-active {
		opacity: 0;
	}

	@media screen and (max-width: 1280px) {
		grid-template-columns: 400px 1fr;
	}
`;

export { StyledContainer };
